import lod_ from "lodash";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { getChatbotConfig } from "redux/reducers/applicationReducer";

const CHATBOT_SCRIPT_ID = "faibrik-chatbot-script";

const useChatbotScript = () => {
	const user = useSelector(state => state.userStatus?.auth?.user);
	const selectedAssistantID = useSelector(state => state.selectedAssistantID);

	const chatbotConfig = useSelector(getChatbotConfig);

	useEffect(() => {
		// Remove existing script if any
		const existingScript = document.getElementById(CHATBOT_SCRIPT_ID);
		if (existingScript) {
			existingScript.remove();
		}

		if (
			lod_.isEmpty(user?.userID) ||
			lod_.isEmpty(selectedAssistantID) ||
			lod_.isEmpty(chatbotConfig) ||
			chatbotConfig.active !== true ||
			lod_.isEmpty(chatbotConfig.scriptUrl) ||
			lod_.isEmpty(chatbotConfig.apiKey)
		) {
			return undefined;
		}

		// Create and inject the chatbot script
		const script = document.createElement("script");
		script.id = CHATBOT_SCRIPT_ID;
		script.src = chatbotConfig.scriptUrl;
		script.async = true;

		// Initialize fAIbrikChat once the script is loaded
		script.onload = () => {
			if (window.fAIbrikChat) {
				window.fAIbrikChat.init({
					communication: {
						apiKey: chatbotConfig.apiKey,

						clientData: {
							userID: user.userID,
							assistantID: selectedAssistantID,
							application: process.env.REACT_APP_NAME,
							metadatas: chatbotConfig.metadatas || {}
						}
					}
				});
			}
		};

		document.body.appendChild(script);

		// Cleanup on unmount or profile change
		const cleanup = () => {
			const scriptToRemove = document.getElementById(CHATBOT_SCRIPT_ID);
			if (scriptToRemove) {
				scriptToRemove.remove();
			}
			// Destroy chat instance if available
			if (window.fAIbrikChat?.destroy) {
				window.fAIbrikChat.destroy();
			}
		};

		return cleanup;
	}, [selectedAssistantID, chatbotConfig]);
};

export default useChatbotScript;
